import React, { useEffect } from 'react';
import { initMetaPixel } from './lib/metaPixel';
import { Hero } from './components/Hero';
import { OpeningHook } from './components/OpeningHook';
import { Problem } from './components/Problem';
import { Failures } from './components/Failures';
import { Mechanism } from './components/Mechanism';
import { Deliverables } from './components/Deliverables';
import { TargetAudience } from './components/TargetAudience';
import { HowItWorks } from './components/HowItWorks';
import { Proof } from './components/Proof';
import { FAQ } from './components/FAQ';
import { OfferBlock } from './components/OfferBlock';
import { Footer } from './components/Footer';
function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="min-h-screen bg-brand-bg text-gray-300 font-sans selection:bg-brand-red/30 selection:text-white" data-id="element-0">
      <Hero data-id="element-1" />
      <OpeningHook data-id="element-2" />
      <Problem data-id="element-3" />
      <Failures data-id="element-4" />
      <Mechanism data-id="element-5" />
      <Deliverables data-id="element-6" />
      <TargetAudience data-id="element-7" />
      <HowItWorks data-id="element-8" />
      <Proof data-id="element-9" />
      <FAQ data-id="element-10" />
      <OfferBlock data-id="element-11" />
      <Footer data-id="element-12" />
    </div>;
}
export { App };